export const mockSelectedVariationAttributes = {
    color: 'BLACKWL',
    size: 'small',
}

export const mockImageGroupsWithOneImage = [
    {
        images: [
            {
                alt: 'hero image one',
                disBaseLink: 'https://via.placeholder.com/150',
                link: 'https://via.placeholder.com/150',
            },
        ],
        viewType: 'large',
    },
    {
        images: [
            {
                alt: 'hero image one',
                disBaseLink: 'https://via.placeholder.com/75',
                link: 'https://via.placeholder.com/75',
            },
        ],
        viewType: 'medium',
    },
    {
        images: [
            {
                alt: 'hero image one',
                disBaseLink: 'https://via.placeholder.com/50',
                link: 'https://via.placeholder.com/50',
            },
        ],
        viewType: 'small',
    },
]

export const mockImageGroupsWithMultipleImages = [
    {
        images: [
            {
                alt: 'hero image one',
                disBaseLink: 'https://via.placeholder.com/150',
                link: 'https://via.placeholder.com/150',
            },
            {
                alt: 'hero image two',
                disBaseLink: 'https://via.placeholder.com/150',
                link: 'https://via.placeholder.com/150',
            },
            {
                alt: 'hero image three',
                disBaseLink: 'https://via.placeholder.com/150',
                link: 'https://via.placeholder.com/150',
            },
        ],
        viewType: 'large',
    },
    {
        images: [
            {
                alt: 'hero image one',
                disBaseLink: 'https://via.placeholder.com/75',
                link: 'https://via.placeholder.com/75',
            },
            {
                alt: 'hero image two',
                disBaseLink: 'https://via.placeholder.com/75',
                link: 'https://via.placeholder.com/75',
            },
            {
                alt: 'hero image three',
                disBaseLink: 'https://via.placeholder.com/75',
                link: 'https://via.placeholder.com/75',
            },
        ],
        viewType: 'medium',
    },
    {
        images: [
            {
                alt: 'hero image one',
                disBaseLink: 'https://via.placeholder.com/50',
                link: 'https://via.placeholder.com/50',
            },
            {
                alt: 'hero image two',
                disBaseLink: 'https://via.placeholder.com/50',
                link: 'https://via.placeholder.com/50',
            },
            {
                alt: 'hero image three',
                disBaseLink: 'https://via.placeholder.com/50',
                link: 'https://via.placeholder.com/50',
            },
        ],
        viewType: 'small',
    },
]

export const mockThumbnailImages = [
    {
        alt: 'thumbnail1',
        disBaseLink: 'https://via.placeholder.com/1',
        link: 'https://via.placeholder.com/1',
        title: 'thumbnail image one',
    },
    {
        alt: 'thumbnail2',
        disBaseLink: 'https://via.placeholder.com/2',
        link: 'https://via.placeholder.com/2',
        title: 'thumbnail image two',
    },
    {
        alt: 'thumbnail3',
        disBaseLink: 'https://via.placeholder.com/3',
        link: 'https://via.placeholder.com/3',
        title: 'thumbnail image three',
    },
    {
        alt: 'thumbnail4',
        disBaseLink: 'https://via.placeholder.com/4',
        link: 'https://via.placeholder.com/4',
        title: 'thumbnail image four',
    },
]

export const mockHeroImageGroup = {
    images: [
        {
            alt: 'hero image one',
            link: 'https://via.placeholder.com/150',
        },
        {
            alt: 'hero image two',
            disBaseLink: 'https://via.placeholder.com/150',
            link: 'https://via.placeholder.com/150',
        },
        {
            alt: 'hero image three',
            disBaseLink: 'https://via.placeholder.com/150',
            link: 'https://via.placeholder.com/150',
        },
    ],
    viewType: 'large',
}

export const libraryImageGalleryData = [
    {
        images: [
            {
                alt: 'Black Flat Front Wool Suit, , large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9d1c5d42/images/large/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9d1c5d42/images/large/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9d1c5d42/images/large/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9d1c5d42/images/large/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
        ],
        viewType: 'large',
    },
    {
        images: [
            {
                alt: 'Black Flat Front Wool Suit, Black, large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9d1c5d42/images/large/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9d1c5d42/images/large/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9d1c5d42/images/large/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9d1c5d42/images/large/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, large',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa79cf278/images/large/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
        ],
        variationAttributes: [
            {
                id: 'color',
                values: [
                    {
                        value: 'BLACKWL',
                    },
                ],
            },
        ],
        viewType: 'large',
    },
    {
        images: [
            {
                alt: 'Black Flat Front Wool Suit, , medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0e81aa38/images/medium/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0e81aa38/images/medium/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0e81aa38/images/medium/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0e81aa38/images/medium/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
        ],
        viewType: 'medium',
    },
    {
        images: [
            {
                alt: 'Black Flat Front Wool Suit, Black, medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0e81aa38/images/medium/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0e81aa38/images/medium/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0e81aa38/images/medium/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0e81aa38/images/medium/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, medium',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc02b1e20/images/medium/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
        ],
        variationAttributes: [
            {
                id: 'color',
                values: [
                    {
                        value: 'BLACKWL',
                    },
                ],
            },
        ],
        viewType: 'medium',
    },
    {
        images: [
            {
                alt: 'Black Flat Front Wool Suit, , small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8a55ec44/images/small/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8a55ec44/images/small/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8a55ec44/images/small/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8a55ec44/images/small/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
            {
                alt: 'Black Flat Front Wool Suit, , small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, ',
            },
        ],
        viewType: 'small',
    },
    {
        images: [
            {
                alt: 'Black Flat Front Wool Suit, Black, small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8a55ec44/images/small/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8a55ec44/images/small/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8a55ec44/images/small/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8a55ec44/images/small/PG.52001DAN84Q.BLACKWL.PZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, small',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56e8cb87/images/small/PG.52001DAN84Q.BLACKWL.BZ.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
        ],
        variationAttributes: [
            {
                id: 'color',
                values: [
                    {
                        value: 'BLACKWL',
                    },
                ],
            },
        ],
        viewType: 'small',
    },
    {
        images: [
            {
                alt: 'Black Flat Front Wool Suit, Black, swatch',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5f1e62b1/images/swatch/PG.52001DAN84Q.BLACKWL.CP.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5f1e62b1/images/swatch/PG.52001DAN84Q.BLACKWL.CP.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, swatch',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5f1e62b1/images/swatch/PG.52001DAN84Q.BLACKWL.CP.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5f1e62b1/images/swatch/PG.52001DAN84Q.BLACKWL.CP.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
            {
                alt: 'Black Flat Front Wool Suit, Black, swatch',
                disBaseLink:
                    'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BLNR_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5f1e62b1/images/swatch/PG.52001DAN84Q.BLACKWL.CP.jpg',
                link: 'https://blnr-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5f1e62b1/images/swatch/PG.52001DAN84Q.BLACKWL.CP.jpg',
                title: 'Black Flat Front Wool Suit, Black',
            },
        ],
        variationAttributes: [
            {
                id: 'color',
                values: [
                    {
                        value: 'BLACKWL',
                    },
                ],
            },
        ],
        viewType: 'swatch',
    },
]
